import { render, staticRenderFns } from "./bill-form-void.vue?vue&type=template&id=452af8c6"
import script from "./bill-form-void.vue?vue&type=script&lang=js"
export * from "./bill-form-void.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports